import { css } from "@emotion/react";
import { useState } from "react";

import DatabaseMenu from "~/components/database/detail/database-content/database-menu";
import { Tp7Color, fixedWidth } from "~/lib/client/design";
import { engFont } from "~/lib/client/fonts";
import { DatabaseDetailPageProps } from "~/pages/database/[id]";

/**
 * データベースの番号やアクションボタンを表示するコンポーネント
 * 幅は 14rem で固定
 *
 * @constructor
 */
const ActionPanel = ({ form }: { form: DatabaseDetailPageProps["form"] }) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const closeMenu = () => setMenuIsOpen(false);
  const toggleMenu = () => setMenuIsOpen((prev) => !prev);

  return (
    <div css={actionPanelStyle} className={engFont.className}>
      <p css={formIdStyle}>#{form.id}</p>
      <DatabaseMenu
        form={form}
        menuIsOpen={menuIsOpen}
        closeMenu={closeMenu}
        toggleMenu={toggleMenu}
      />
    </div>
  );
};

const actionPanelStyle = css`
  ${fixedWidth("14rem")}
  min-height: 17.5rem;
  height: 100%;

  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const formIdStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  color: ${Tp7Color.text};
  font-size: 36pt;
  padding-top: 5rem;
  margin: 0.5rem;
`;

export default ActionPanel;
